function eq(value, other) {
  return value === other || value !== value && other !== other;
}
export {
  eq as default
};
//# sourceMappingURL=eq.js.map
